import React, { FC, ComponentType } from 'react'
import { Field, FieldProps } from 'formik'

export type FormikFieldProps = {
  className?: string
  name?: string
  hidden?: boolean
  Component: ComponentType<any>
  onChange?: (e: React.ChangeEvent<any>) => void
  hideError?: boolean
  [key: string]: any
  slotBefore?: React.ReactNode
}

const FormikField: FC<FormikFieldProps> = ({
  name,
  hidden,
  Component,
  hideError,
  slotBefore,
  ...rest
}) => {
  return (
    <Field name={name} {...rest}>
      {({ meta, field }: FieldProps) => {
        const fieldError = meta.error
        const hasError = meta.touched && !!fieldError

        const onChange = (e: React.ChangeEvent<any>) => {
          field.onChange(e)
          rest?.onChange?.(e)
        }

        return (
          <Component
            {...rest}
            {...field}
            onChange={onChange}
            hasError={!hidden ? hasError : undefined}
            error={hasError && !hideError ? fieldError : undefined}
            slotBefore={slotBefore}
          />
        )
      }}
    </Field>
  )
}

export default FormikField
